module.exports = __webpack_public_path__ + "static/media/school.3757b8ba.jpg";